export const localStorageConstants = {
  favoriteList: 'favoriteList',
  currentLanguage: 'currentLanguage',
};
